import styled from 'styled-components';

export default styled.div`
  margin: auto;
  display: block;
  position: relative;
  height: 100%;
  width: 100%;
  
  ${props => props.onClick ? 'cursor: pointer;' : ''}
  ${props => props.thisStylesWrapper}

  &:hover {
    & svg > path {
      ${props => props.iconStyles && props.iconStyles.hoverIconFill  ? `fill: ${props.iconStyles.hoverIconFill}` : ''};
      ${props => props.iconStyles && props.iconStyles.hoverIconStroke  ? `stroke: ${props.iconStyles.hoverIconStroke}` : ''};
    }

    & svg > circle {
      ${props => props.iconStyles && props.iconStyles.hoverIconFill  ? `fill: ${props.iconStyles.hoverIconFill}` : ''};
      ${props => props.iconStyles && props.iconStyles.hoverIconStroke  ? `stroke: ${props.iconStyles.hoverIconStroke}` : ''};
    }

    & svg > rect {
      ${props => props.iconStyles && props.iconStyles.hoverIconFill  ? `fill: ${props.iconStyles.hoverIconFill}` : ''};
      ${props => props.iconStyles && props.iconStyles.hoverIconStroke  ? `stroke: ${props.iconStyles.hoverIconStroke}` : ''};
    }

    & svg > polygon {
      ${props => props.iconStyles && props.iconStyles.hoverIconFill  ? `fill: ${props.iconStyles.hoverIconFill}` : ''};
      ${props => props.iconStyles && props.iconStyles.hoverIconStroke  ? `stroke: ${props.iconStyles.hoverIconStroke}` : ''};
    }
    ${props => props.thisStylesHoverWrapper}
  }

  & svg {
    display: block;
    height: ${props => props.iconSize || 'initial'};
    width: ${props => props.iconSize || 'initial'};
  }

  & svg > path {
    ${props => props.iconStyles && props.iconStyles.iconFill  ? `fill: ${props.iconStyles.iconFill}` : ''};
    ${props => props.iconStyles && props.iconStyles.iconStroke  ? `stroke: ${props.iconStyles.iconStroke}` : ''};
  }

  & svg > circle {
    ${props => props.iconStyles && props.iconStyles.iconFill  ? `fill: ${props.iconStyles.iconFill}` : ''};
    ${props => props.iconStyles && props.iconStyles.iconStroke  ? `stroke: ${props.iconStyles.iconStroke}` : ''};
  }

  & svg > rect {
    ${props => props.iconStyles && props.iconStyles.iconFill  ? `fill: ${props.iconStyles.iconFill}` : ''};
    ${props => props.iconStyles && props.iconStyles.iconStroke  ? `stroke: ${props.iconStyles.iconStroke}` : ''};
  }

  & svg > polygon {
    ${props => props.iconStyles && props.iconStyles.iconFill  ? `fill: ${props.iconStyles.iconFill}` : ''};
    ${props => props.iconStyles && props.iconStyles.iconStroke  ? `stroke: ${props.iconStyles.iconStroke}` : ''};
  }

`;
